/* global SmartOrderRefillSettings */
/**
 *  Property of OSF GLOBAL SERVICES INC. , an OSF Digital company. OSF remains the sole owner of all right, title and interest in the software. Do not copy, sell, reverse engineer or otherwise attempt to derive or obtain information about the functioning, manufacture or operation therein.
 */

const sorHelpers = require('../sorHelpers/sorHelpers');

let addressChangeInfo;

const addressChangeFormSave = function (hostOrEvent) {
  const $form = $('#editAddressForm');
  const formValid = sorHelpers.sorValidation.validateForm($form);
  const $loaderHost =
    hostOrEvent && hostOrEvent.currentTarget ? sorHelpers.sorLoader.getModalHost($(hostOrEvent.currentTarget)) : hostOrEvent;
  const stopLoader = function () {
    sorHelpers.sorLoader.stop($loaderHost);
  };

  if (formValid) {
    sorHelpers.sorLoader.start($loaderHost);
  }

  setTimeout(function () {
    if (!formValid) {
      return;
    }
    $.ajax({
      type: 'POST',
      url: $form.attr('action'),
      data: $form.serialize()
    })
      .done(function (response) {
        if (response) {
          if (response.success) {
            const bootstrapModalBody = $(addressChangeInfo.target).find('.modal .modal-body');
            if (bootstrapModalBody.length > 0) {
              addressChangeInfo.target = bootstrapModalBody;
            }
            $(addressChangeInfo.target).load(addressChangeInfo.urlview, function () {
              sorHelpers.sorCharLimitation.limitCharacters();
            });
            window.location.href = SmartOrderRefillSettings.Urls.manageOrders;
          } else if ($('input[name$="_postal"]:invalid').length) {
            stopLoader();
            $('input[name$="_postal"]')
              .parent()
              .append('<label class="error">' + SmartOrderRefillSettings.Resources.INVALID_ZIP + '</label>');
          } else {
            stopLoader();
          }
        } else {
          stopLoader();
          sorHelpers.sorModal.initWarningModal(SmartOrderRefillSettings.Resources.SOR_ADDRESS_ERROR);
        }
      })
      .fail(function (err) {
        if (err.responseJSON && err.responseJSON.redirectURL) {
          window.location.href = err.responseJSON.redirectURL;
        } else {
          stopLoader();
          sorHelpers.sorModal.initErrorModal(SmartOrderRefillSettings.Resources.SOR_UNEXPECTED_ERROR);
        }
      });
  }, 1000);
};

const confirmAddressForm = function (e) {
  const $form = $('#editAddressForm');
  const formValid = sorHelpers.sorValidation.validateForm($form);

  if (!formValid) {
    return;
  }

  const ordersDateList = JSON.parse(decodeURIComponent($form.data('customAddressShipmentDates')));
  if (!ordersDateList || !ordersDateList.length) {
    addressChangeFormSave(sorHelpers.sorLoader.getModalHost($(e.currentTarget)));
    return;
  }

  const $container = sorHelpers.sorModal.createContainer('#addresschangeconfirm');
  $container.html(`
        <div>
            <p>
                ${SmartOrderRefillSettings.Resources.SOR_CHANGEADDRESS_CONFIRMATION_TEXT}
            </p>
            <ul style="margin-top: 8px;">
                ${ordersDateList.map((id) => `<li>${id}</li>`).join('')}
            </ul>
        </div>
    `);

  sorHelpers.sorModal.createModal($container, {
    autoOpen: true,
    bgiframe: true,
    modal: true,
    emptyOnClose: false,
    width: '25rem',
    title: SmartOrderRefillSettings.Resources.SOR_CHANGEADDRESS_CONFIRMATION_TITLE,
    buttons: {
      SOR_GLOBAL_CANCEL: sorHelpers.sorModal.closeModal,
      SOR_GLOBAL_SAVE: addressChangeFormSave
    }
  });
};

const addressChangeFormOptions = function (target, urlview, container) {
  addressChangeInfo = {
    target: target,
    urlview: urlview,
    container: container
  };
  return {
    autoOpen: true,
    bgiframe: true,
    modal: true,
    emptyOnClose: false,
    title: SmartOrderRefillSettings.Resources.SOR_CHANGE_ADDRESS_TITLE,
    buttons: {
      SOR_GLOBAL_CLOSE: sorHelpers.sorModal.closeModal,
      SOR_GLOBAL_SAVE: confirmAddressForm
    }
  };
};

const initAddressChangeForm = function (target, urlview) {
  $(document)
    .off('click', '.changeaddress')
    .on('click', '.changeaddress', function (e) {
      if (!e.detail || e.detail === 1) {
        e.preventDefault();
        const $parentHost = sorHelpers.sorLoader.getModalHost($(this));
        if ($parentHost.hasClass('sor-loader-host')) {
          return;
        }
        sorHelpers.sorLoader.start($parentHost);
        const url = $(this).attr('data-link');
        const $container = sorHelpers.sorModal.createContainer('#addresschange');

        $container.load(url, function (response, status) {
          if (status === 'error') {
            sorHelpers.sorLoader.stop($parentHost);
            return;
          }
          sorHelpers.sorModal.createModal($container, addressChangeFormOptions(target, urlview, $container));
          sorHelpers.sorModal.onShown($container, function () {
            sorHelpers.sorLoader.stop($parentHost);
          });
          const $form = $('#editAddressForm');

          $(document).on('change', '#dwfrm_changeaddress_states_stateCode, #dwfrm_changeaddress', function () {
            // ISML is rendered by the backend which automatically sets the data-id of the 'Save' button in the locale language, so the possible 'save' options are listed here
            const saveOptions = ['Salva', 'Save'];
            let $sumbitButton;
            // eslint-disable-next-line prefer-const
            for (let i in saveOptions) {
              $sumbitButton = $('#addresschange').find(`button[data-id=${saveOptions[i]}]`);
              if ($sumbitButton.length) {
                break;
              }
            }
            const $changeAddressError = $('#changeAddressError');
            const $formData = $form.serializeArray();
            const urlParams = new URLSearchParams($form.attr('action'));
            const subscriptionID = urlParams.get('sid');
            const orderID = urlParams.get('oid');
            const $shippingMethodSelectField = $('#dwfrm_changeaddress_shippingMethodID');
            if (!$shippingMethodSelectField.length) {
              return;
            }
            const shippingURL = $shippingMethodSelectField.data('url');
            $formData.push({ name: 'sid', value: subscriptionID });
            $formData.push({ name: 'oid', value: orderID });
            $changeAddressError.empty();
            $sumbitButton.prop('disabled', true);
            $shippingMethodSelectField.empty();
            $.ajax({
              url: shippingURL,
              type: 'post',
              dataType: 'json',
              data: $formData,
              success: function (data) {
                if (data.applicableShippingMethods && data.applicableShippingMethods.length > 0) {
                  for (let index = 0; index < data.applicableShippingMethods.length; index += 1) {
                    const shippingMethod = data.applicableShippingMethods[index];
                    const estimatedArrivalTime = shippingMethod.estimatedArrivalTime ? shippingMethod.estimatedArrivalTime : '';
                    $shippingMethodSelectField.append(
                      `<option value="${shippingMethod.ID}" label="${shippingMethod.displayName} ${estimatedArrivalTime} ${shippingMethod.shippingCost}">${shippingMethod.displayName}</option>`
                    );
                  }
                  $sumbitButton.prop('disabled', false);
                } else {
                  $changeAddressError.text(SmartOrderRefillSettings.Resources.SOR_CHANGEADDRESS_ERROR_NOSHIPPING);
                }
              },
              error: function () {
                $changeAddressError.text(SmartOrderRefillSettings.Resources.SOR_CHANGEADDRESS_ERROR_SHIPPING);
              }
            });
          });

          $('#dwfrm_changeaddress_country').on('change', function () {
            const countryValue = $(this).val();
            const stateCode = 'stateCode' + countryValue;

            $('.state-selections').each(function () {
              const stateSelection = $(this);
              stateSelection.toggleClass('d-none', !stateSelection.hasClass(stateCode));
            });
          });

          $('select[name$="_changeaddress"]', $form).on('change', function () {
            const selected = $(this).children(':selected').first();
            const selectedAddress = $(selected).data('address');
            if (!selectedAddress) {
              return;
            }
            sorHelpers.sorUtils.fillAddressFields(selectedAddress, $form);
            sorHelpers.sorValidation.validateForm($form);
            $('#dwfrm_changeaddress_states_state').trigger('change');
            $('#dwfrm_changeaddress_country').trigger('change');
          });
        });
      }
    });
};

module.exports = {
  initAddressChangeForm: initAddressChangeForm
};
